import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import GeoFenceManagement from './GeoFenceManagement';
import AttendanceTracking from './AttendanceTracking';
import AttendanceReports from './AttendanceReports';
import AttendanceRegularization from './AttendanceRegularization';
import AttendanceAnalytics from './AttendanceAnalytics';
import ShiftManagement from './ShiftManagement';
import LeaveManagement from './LeaveManagement';
import HolidayManagement from './HolidayManagement';
import ScheduleManagement from './ScheduleManagement';
import ClientFilter from './ClientFilter';

const EmployeeManagementTabs = ({ userProfile, selectedEmployeeForAttendance }) => {
  const [activeTab, setActiveTab] = useState('employees');
  const [selectedClientId, setSelectedClientId] = useState(null);

  const tabs = [
    { id: 'geo-fences', label: 'Geo-fences', icon: 'MapPin', description: 'Manage attendance locations' },
    { id: 'attendance', label: 'Attendance', icon: 'Clock', description: 'Track attendance' },
    { id: 'reports', label: 'Reports', icon: 'FileText', description: 'View attendance reports' },
    { id: 'analytics', label: 'Analytics', icon: 'BarChart3', description: 'Attendance analytics' },
    { id: 'regularization', label: 'Regularization', icon: 'FileCheck', description: 'Attendance corrections' },
    { id: 'shifts', label: 'Shifts', icon: 'Clock', description: 'Manage work shifts' },
    { id: 'leaves', label: 'Leaves', icon: 'Calendar', description: 'Manage leave records' },
    { id: 'holidays', label: 'Holidays', icon: 'Calendar', description: 'Manage public holidays' },
    { id: 'schedules', label: 'Schedules', icon: 'CalendarDays', description: 'Manage employee schedules' }
  ];

  const isAdmin = userProfile?.role === 'super_admin' || userProfile?.role === 'hr_admin';

  return (
    <div>
      {/* Client Filter - Global for all modules */}
      <div className="mb-4 bg-card border border-border rounded-lg p-4 shadow-sm">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Icon name="Building2" size={20} className="text-primary shrink-0" />
            <div>
              <h3 className="text-sm font-semibold text-foreground leading-snug">Client Filter</h3>
              <p className="text-xs text-muted-foreground whitespace-nowrap">Filter all modules by client</p>
            </div>
          </div>
          <div className="w-full sm:w-72">
            <ClientFilter 
              value={selectedClientId} 
              onChange={setSelectedClientId}
              showLabel={false}
            />
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-border">
        <nav className="flex space-x-8 overflow-x-auto">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="bg-card border border-border rounded-lg">
        {activeTab === 'geo-fences' && isAdmin && <GeoFenceManagement clientId={selectedClientId} />}
        {activeTab === 'geo-fences' && !isAdmin && (
          <div className="p-8 text-center text-muted-foreground">
            <Icon name="Lock" size={48} className="mx-auto mb-4 opacity-50" />
            <p>Access restricted. Only administrators can manage geo-fences.</p>
          </div>
        )}
        {activeTab === 'attendance' && (
          <AttendanceTracking 
            userProfile={userProfile} 
            selectedEmployeeForAttendance={selectedEmployeeForAttendance}
            clientId={selectedClientId}
          />
        )}
        {activeTab === 'reports' && <AttendanceReports isAdmin={isAdmin} clientId={selectedClientId} />}
        {activeTab === 'analytics' && <AttendanceAnalytics isAdmin={isAdmin} clientId={selectedClientId} />}
        {activeTab === 'regularization' && <AttendanceRegularization isAdmin={isAdmin} userProfile={userProfile} clientId={selectedClientId} />}
        {activeTab === 'shifts' && <ShiftManagement isAdmin={isAdmin} clientId={selectedClientId} />}
        {activeTab === 'leaves' && <LeaveManagement isAdmin={isAdmin} clientId={selectedClientId} />}
        {activeTab === 'holidays' && <HolidayManagement isAdmin={isAdmin} clientId={selectedClientId} />}
        {activeTab === 'schedules' && <ScheduleManagement isAdmin={isAdmin} clientId={selectedClientId} />}
      </div>
    </div>
  );
};

export default EmployeeManagementTabs;

